import { Channel } from "@/controllers/channel/schema";

export function getMemberLabels(
  loggedUser: { id: string },
  channel: Channel,
  shortLabel = false,
  firstN = 2,
) {
  const members =
    channel?.members.filter((member) => member.id !== loggedUser.id) ?? [];

  const memberNames = members
    .slice(0, firstN)
    .map((member) => {
      if (!shortLabel) {
        return member.name;
      }

      const parts = member.name.split(" ");
      if (parts.length === 1) {
        return parts[0];
      }

      return `${parts[0]} ${parts[1].at(0)}`;
    })
    .join(", ");
  const remainingCount = members.length - firstN;

  return {
    members: members.slice(0, firstN),
    memberNames,
    remainingCount,
  };
}
